import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/orders',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/orders/phaseTransportDemand',
      name: 'phaseTransportDemand',
      component: () => import('@/pages/myOrders/phaseTransportDemand.vue'),
      meta: {
        ...meta,
        title: '月运输需求',
        requireAuth: true
      }
    },
    {
      path: '/orders/phaseTransportDemand/phaseTransportDemandDetail',
      name: 'phaseTransportDe',
      component: () => import('@/pages/myOrders/phaseTransportDemandDetail.vue'),
      meta: {
        ...meta,
        title: '月运输详情',
        requireAuth: true
      }
    },
    {
      path: '/orders/dailyTransportDemand',
      name: 'dailyTransportDemand',
      component: () => import('@/pages/myOrders/dailyTransportDemand.vue'),
      meta: {
        ...meta,
        title: '日运输需求',
        requireAuth: true
      }
    },
    {
      path: '/orders/dailyTransportDemand/dailyTransportDemandDetail',
      name: 'dailyTransportDeman',
      component: () => import('@/pages/myOrders/dailyTransportDemandDetail.vue'),
      meta: {
        ...meta,
        title: '日运输详情',
        requireAuth: true
      }
    },
    {
      path: '/orders/leagueOfNationsWaybill/leagueOfNationsWaybill',
      name: 'leagueOfNationsWaybill',
      component: () => import('@/pages/myOrders/leagueOfNationsWaybill/leagueOfNationsWaybill.vue'),
      meta: {
        ...meta,
        title: '国联运单',
        requireAuth: true
      }
    },
    {
      path: '/orders/leagueOfNationsWaybill/waybillEdit',
      name: 'waybillEdit',
      component: () => import('@/pages/myOrders/leagueOfNationsWaybill/waybillEdit.vue'),
      meta: {
        ...meta,
        title: '国联运单编辑', // 国联运单编辑/详情页面
        requireAuth: true
      }
    },
    {
      path: '/orders/preDepositDetailCustomer',
      name: 'preDepositDetailCustomer',
      component: () => import('@/pages/myOrders/preDepositDetailCustomer.vue'),
      meta: {
        ...meta,
        title: '预付款交易明细',
      }
    },
    {
      path: '/orders/transportStatistics',
      name: 'transportStatistics',
      component: () => import('@/pages/myOrders/transportStatistics/index.vue'),
      meta: {
        ...meta,
        title: '货运统计',
        requireAuth: true
      },
    },
    {
      path: '/orders/containerDelete',
      name: 'containerDelete',
      component: () => import('@/pages/myOrders/containerDelete/index.vue'),
      meta: {
        ...meta,
        title: '运单作废',
        requireAuth: true
      }
    },
    {
      path: '/orders/jqsdOrderManager',
      name: 'jqsdOrderManager',
      component: () => import('@/pages/logistics/jqsdpd/index.vue'),
      meta: {
        ...meta,
        title: '接取送达单查询',
        requireAuth: true
      }
    },
    {
      path: '/orders/jqsdOrderSign',
      name: 'jqsdOrderSign',
      component: () => import('@/pages/logistics/jqsdqr/index.vue'),
      meta: {
        ...meta,
        title: '接取送达单签认',
        requireAuth: true
      }
    },
    {
      path: '/orders/containerPreOrderQry',
      name: 'containerPreOrderQry',
      component: () => import('@/pages/myOrders/containerPreOrderQry/index.vue'),
      meta: {
        ...meta,
        title: '预定箱列表',
        requireAuth: true
      }
    },
    {
      path: '/orders/confirmationBill',
      name: 'confirmationBill',
      component: () => import('@/pages/myOrders/confirmationBill.vue'),
      meta: {
        ...meta,
        title: '票据确认',
        // requireAuth: true
      }
    },
  ]
}
